<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
        <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>AGENDA</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item">
          <div class="item-title">
            <span class="item-title-content">VALSE 2026 会议总体日程</span>
          </div>
          <div class="item-content">
            <div class="item-content-info">
              <p><span class="text-black-border">会议时间：</span>2026年5月8日—10日</p>
              <p><span class="text-black-border">会议地点：</span>武汉国际会议中心</p>
              <p class="schedule-note">以下日程摘自《VALSE2026日程》，分会场具体场地以现场指引为准。</p>
            </div>

            <div class="item-content-title">5月8日（星期五）</div>
            <table class="program-table" cellspacing="0" cellpadding="0">
              <tr>
                <th class="time-td">时间</th>
                <th>内容</th>
                <th class="didian-td">地点</th>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">08:30-09:10</span></td>
                <td class="td-content">
                  <div class="td-title">开幕式</div>
                  <div class="td-content">颁发赞助商感谢牌</div>
                </td>
                <td rowspan="15" class="didian-td">5F主会场大宴会厅</td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">09:10-09:40</span></td>
                <td>
                  <div class="td-title">大会主旨报告-1</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">凌海滨 (西湖大学)                    </span></div>
                  <div class="td-content">报告题目：VALSAR:Vision And Learning for Spatial Augmented Reality</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">09:40-10:10</span></td>
                <td>
                  <div class="td-title">大会主旨报告-2</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">黄华 (北京师范大学) </span></div>
                  <div class="td-content">报告题目：教育文档处理的关键技术</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">10:10-10:40</span></td>
                <td>
                  <div class="td-title">大会主旨报告-3</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">曹汛 (南京大学)</span></div>
                  <div class="td-content">报告题目：AI-Empowered Computational Cameras: Beyond Human Vision</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">10:40-11:00</span></td>
                <td>
                  <div class="td-title">铂金企业宣讲</div>
                  <div class="td-content">报告人：卢宁（华为）；报告题目：智能座舱MoLA架构在Agentic时代下的机遇与挑战</div>
                  <div class="td-content">报告人：余佳（AutoDL）；报告题目：破解用卡难复现难解决方案</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">11:00-11:15</span></td>
                <td class="td-title">休息</td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">11:15-11:30</span></td>
                <td class="td-content">2025-2026年度CV与ML领域重要学术进展</td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">11:30-12:00</span></td>
                <td>
                  <div class="td-title">年度进展评述（一）</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">彭宇新（北京大学）</span><br/>题目：细粒度多模态大模型</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">欧阳万里 (深圳河套学院、上海人工智能实验室)</span><br/>题目：人工智能助力科学发现</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">12:00-13:30</span></td>
                <td class="td-title">午餐</td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">13:30-14:00</span></td>
                <td>
                  <div class="td-title">大会主旨报告-4</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">潘纲 (浙江大学) </span></div>
                  <div class="td-content">报告题目：脑机增强智能新范式</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">14:00-14:30</span></td>
                <td>
                  <div class="td-title">大会主旨报告-5</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">虞晶怡 (上海科技大学) </span></div>
                  <div class="td-content">报告题目：Speaking the Language of Space: Automating 3D Workflows with Agentic Vision
                  </div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">14:30-15:00</span></td>
                <td>
                  <div class="td-title">铂金企业宣讲</div>
                  <div class="td-content">报告人：陈光（小米集团）；报告题目：强化认知驱动的端到端智能驾驶</div>
                  <div class="td-content">报告人：黄青虬（墨奇智能）；报告题目：爬向物理世界的AGI</div>
                  <div class="td-content">报告人：战春儒（阿里巴巴淘天集团）；报告题目：淘天AIGC：模型能力建设与应用实践</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">15:00-15:15</span></td>
                <td class="td-title">休息</td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">15:15-18:00</span></td>
                <td>
                  <div class="td-title">年度进展评述（二）</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">戴国浩（上海交通大学）</span><br/>题目：大模型高效计算与推理</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">郝建业（天津大学）</span><br/>题目：基于大语言模型的智能体</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">高林（中国科学院计算技术研究所）</span><br/>题目：以人为中心的视觉内容生成</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">秦杰（南京航空航天大学）</span><br/>题目：开放世界目标检测</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">张正（哈尔滨工业大学（深圳））</span><br/>题目：端侧轻量化大模型</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">韩波（香港浸会大学）</span><br/>题目：迈向可信大模型：学习，推理和泛化</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">邓磊（清华大学）</span><br/>题目：脉冲神经网络</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">崔兆鹏（浙江大学）</span><br/>题目：物理驱动的空间智能</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">杨学（上海交通大学）</span><br/>题目：有向目标检测</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">傅朝友（南京大学）</span><br/>题目：多模态交互大模型</div>
                  <div class="td-content"><span>讲者：</span><span class="font-weight">仉尚航 (北京大学)</span><br/>题目：开放世界具身智能多模态大模型与大数据</div>
                </td>
              </tr>
              <tr>
                <td class="time-td"><span class="font-weight">18:30-21:00</span></td>
                <td class="td-title">VIP交流活动</td>
              </tr>
            </table>

            <div class="item-content-title">5月9日（星期六）</div>
            <p class="parallel-hint parallel-hint-highlight"><span class="text-black-border">08:30-12:00</span> Workshop / Tutorial（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 1：智能体AI</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：黄超（香港大学），沈永亮（浙江大学），刘卫文 (上海交通大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉旗厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 2：视觉基础模型</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：左旺孟（哈尔滨工业大学）赵恒爽（香港大学）李翔（南开大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江天厅 </div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 1：VLA</div>
                <div class="parallel-meta">组织者：刘敏（湖南大学），穆尧（上海交通大学），仉尚航（北京大学），石恒璨（湖南大学），张杰（中国科学院计算技术研究所）</div>
                <div class="parallel-meta">讲者：宋井宽 (同济大学)，任文琦 (中山大学)，叶茫 (武汉大学)，于超 (清华大学)，黄青虬 (墨奇智能 & 武汉大学)，翟少鹏 (上海人工智能实验室)</div>
                <div class="parallel-meta">Panel嘉宾：宋井宽（同济大学）、任文琦（中山大学）、叶茫（武汉大学）、于超（清华大学）、翟少鹏（上海人工智能实验室）、黄青虬（墨奇智能 & 武汉大学）、苏航（清华大学）、张力（复旦大学）、马道林（上海交通大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉卷厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 2：智能推理：视觉推理、科学推理</div>
                <div class="parallel-meta">组织者：董胤蓬（清华大学），苏航（清华大学），山世光（中国科学院计算技术研究所），邓志杰（上海交通大学）</div>
                <div class="parallel-meta">讲者：国雍 (华为)，黄高 (清华大学)，桂韬（复旦大学），邓志杰 (上海交通大学)，王欢 (西湖大学)</div>
                <div class="parallel-meta">Panel嘉宾：黄高（清华大学）、桂韬（复旦大学）、邓志杰（上海交通大学）、王欢（西湖大学）、国雍（华为）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉星厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 3：大语言模型与人机交互</div>
                <div class="parallel-meta">组织者：户保田（哈尔滨工业大学（深圳））</div>
                <div class="parallel-meta">讲者：邱锡鹏（复旦大学），东昱晓 (清华大学)，徐进 (阿里巴巴)，林洲汉 (上海交通大学)，陈谐 (上海交通大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉琴厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 4：AI4Science</div>
                <div class="parallel-meta">组织者：杨易（浙江大学），范鹤鹤（浙江大学），唐彦嵩（清华大学），黄强（哈尔滨工业大学（深圳）），王韫博（上海交通大学）</div>
                <div class="parallel-meta">讲者：严骏驰 (上海交通大学)，白琮 (浙江工业大学)，袁亚飞 (清华大学)，荣钰 (阿里巴巴达摩院)，魏颖 (浙江大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江穆厅</div>

              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 5：未来终端影像技术</div>
                <div class="parallel-meta">组织者：程明明（南开大学)，卢湖川（大连理工大学），王立君（大连理工大学），郭春乐（南开大学）高广谓（南京理工大学）</div>
                <div class="parallel-meta">讲者：潘金山 (南京理工大学)，顾舒航 (电子科技大学)，王立志 (北京师范大学)，夏靖远 (国防科技大学)，张志路 (哈尔滨工业大学)</div>
                <div class="parallel-meta">Panel嘉宾：张磊（香港理工大学）、左旺孟（哈尔滨工业大学）、潘金山（南京理工大学）、顾舒航（电子科技大学）、王立志（北京师范大学）、夏靖远（国防科技大学）、张志路（哈尔滨工业大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江耀厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 6：神经符号智能</div>
                <div class="parallel-meta">组织者：戴望州（南京大学），丁尧相（浙江大学），郭兰哲（南京大学），黎铭（南京大学）</div>
                <div class="parallel-meta">讲者：杨博 (吉林大学)，况琨 (浙江大学)，朱毅鑫 (北京大学)，李昊轩 (北京大学)，Haiyan Yin (新加坡A*)，丁尧相（浙江大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江海厅</div>
              </div>
              
            </div>
            <p class="parallel-hint parallel-hint-highlight" style="font-weight: bolder;font-size: large; color: brown;"><span class="text-black-border">12:00-13:30</span> Poster (5F汉清厅&汉翔厅) / 午餐(3F)</p>
            
            <p class="parallel-hint parallel-hint-highlight"><span class="text-black-border">13:30-17:00</span> Workshop / Tutorial（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 3：具身智能基础模型</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：蒋树强（中国科学院大学），李弘扬（香港大学），穆尧（上海交通大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉旗厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Tutorial 4：空间智能</div>
                <div class="parallel-meta">组织者：张利军（南京大学），李辉（江南大学），王兴刚（华中科技大学），左旺孟（哈尔滨工业大学）</div>
                <div class="parallel-meta">讲者：杨蛟龙（微软亚洲研究院），李崇轩（中国人民大学），彭思达（浙江大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江天厅 </div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 7：视频生成技术</div>
                <div class="parallel-meta">组织者：高常鑫（华中科技大学），袁粒（北京大学），武宇（武汉大学）</div>
                <div class="parallel-meta">讲者：储瑞航（阿里巴巴），朱政 (极佳科技)，吴祖煊 (复旦大学)，何声一（百度）、侯淇彬 (南开大学)，齐晓娟（香港大学）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉卷厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 8：可信智能与AI安全</div>
                <div class="parallel-meta">组织者：王骞（武汉大学），沈超（西安交通大学），魏云超（北京交通大学）</div>
                <div class="parallel-meta">讲者：张阳 (德国亥姆霍兹信息安全中心)，刘安安 (天津大学)，温正琪 (清华大学)，秦湛 (浙江大学)，李政 (山东大学)，何新磊 (武汉大学)，杨乐 (西安交通大学)，刘卓然 (荷兰拉德堡德大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉星厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 9：文档图像智能</div>
                <div class="parallel-meta">组织者：刘禹良（华中科技大学）、周宇（南开大学）、白翔（华中科技大学）</div>
                <div class="parallel-meta">讲者：陈智能 (复旦大学)，何聪辉 (上海人工智能实验室)，刘毅 (百度)，付彬 (中国科学院深圳先进技术研究院)，刘强 (金山办公)，陈伟 (华中科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉琴厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 4：AI4Science</div>
                <div class="parallel-meta">组织者：杨易（浙江大学），范鹤鹤（浙江大学），唐彦嵩（清华大学），黄强（哈尔滨工业大学（深圳）），王韫博（上海交通大学）</div>
                <div class="parallel-meta">讲者：许岩岩 (上海交通大学)，王韫博 (上海交通大学)，吴泰霖 (西湖大学)，全睿杰 (浙江大学)，林森林 (哈尔滨工业大学 (深圳))</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江穆厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 10：视觉质量评测与后训练强化学习</div>
                <div class="parallel-meta">组织者：刘笑宏（上海交通大学），马柯德（香港城市大学），赵铁松（福州大学）</div>
                <div class="parallel-meta">讲者：张磊 (香港理工大学)，李雷达 (西安电子科技大学)，陈启峰 (香港科技大学)，赵世杰 (字节跳动)，张子澄 (上海人工智能实验室)</div>
                <div class="parallel-meta">Panel嘉宾：张磊（香港理工大学）、李雷达（西安电子科技大学）、陈启峰（香港科技大学）、赵世杰（字节跳动）、张子澄（上海人工智能实验室）、刘笑宏（上海交通大学）、赵铁松（福州大学）、董超（中国科学院深圳先进技术研究院）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江耀厅</div>
              </div>

              <div class="parallel-item">
                <div class="parallel-name">Workshop 11：机器学习理论与优化</div>
                <div class="parallel-meta">组织者：刘日升（大连理工大学），林宙辰（北京大学）</div>
                <div class="parallel-meta">讲者：张兴义 (安徽大学)，刘新旺 (国防科技大学)，葛冬冬 (上海交通大学)，李武军 (南京大学)，孙若愚 (香港中文大学 (深圳))，王奕森 (北京大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江海厅</div>
              </div>
              
            </div>
            <p class="parallel-hint parallel-hint-highlight" style="font-weight: bolder;font-size: large; color: brown;"><span class="text-black-border">17:00-18:30</span> Poster (5F汉清厅&汉翔厅)</p>

            <div class="item-content-title">5月10日（星期日）</div>
            <p class="parallel-hint parallel-hint-highlight"><span class="text-black-border">08:30-12:00</span> Workshop（以下并行举行）</p>
            <div class="parallel-list">
              <div class="parallel-item">
                <div class="parallel-name">Workshop 12：世界模型</div>
                <div class="parallel-meta">组织者：阚美娜（中国科学院计算技术研究所），张兆翔（中国科学院自动化研究所），鲁继文（清华大学）</div>
                <div class="parallel-meta">讲者：徐凯 (中科院工业人工智能研究所)，段岳圻 (清华大学)，靳潇杰（北京交通大学），王韫博 (上海交通大学)，范略 (中科院自动化研究所)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉旗厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 13：多模态大模型</div>
                <div class="parallel-meta">组织者：刘勇（中国人民大学），王文海（香港中文大学），彭宇新（北京大学）</div>
                <div class="parallel-meta">讲者：彭宇新 (北京大学)，魏秀参 (东南大学)，李亮 (中国科学院计算技术研究所)，黄雷 (北京航空航天大学)，元玉慧 (canvas中国)，李晓彤（美团）</div>
                <div class="parallel-meta">Panel嘉宾：彭宇新（北京大学）、李亮（中国科学院计算技术研究所）、魏秀参（东南大学）、黄雷（北京航空航天大学）、元玉慧（canvas中国），李晓彤（美团）</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉卷厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 14：遥感解译</div>
                <div class="parallel-meta">组织者：夏桂松（武汉大学），张洪艳（中国地质大学（武汉）），孙显（中国科学院空天信息创新研究院）</div>
                <div class="parallel-meta">讲者：史振威 (北京航空航天大学)，刘瑜 (清华大学)，康旭东 (湖南大学)，谢卫莹 (西安电子科技大学)，任超 (中国科学院空天信息创新研究院)，余磊 (武汉大学)，刘天竹 (哈尔滨工业大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉星厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 15：多模态学习助力智慧医疗：从科研到落地</div>
                <div class="parallel-meta">组织者：许永超（武汉大学）、王妍（华东师范大学）、雷柏英（深圳大学）</div>
                <div class="parallel-meta">讲者：刘贤明 (哈尔滨工业大学)，李震 (华中科技大学同济医院)，谢伟迪（上海交通大学）、肖洒（中国科学院精密测量院）、檀韬 (澳门理工大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：5F汉琴厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 16：优秀学生论坛</div>
                <div class="parallel-meta">组织者：韩晓光（香港中文大学（深圳））、李翔（南开大学）、彭思达（浙江大学）、李贤芝（华中科技大学）</div>
                <div class="parallel-meta">讲者：陈铮 (上海交通大学)，余济闻 (香港大学)，张亦弛 (清华大学)，杨佳智 (香港中文大学)，李春一 (南洋理工大学)，胡腾 (上海交通大学)，陈麒光 (哈尔滨工业大学)，陈翔 (南京理工大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江天厅 </div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 17：持续学习与持续智能体</div>
                <div class="parallel-meta">组织者：谢源（上海创智学院），刘夏雷（南开大学），张志忠（华东师范大学）</div>
                <div class="parallel-meta">讲者：徐常胜 (中国科学院自动化研究所)，苏劲松 (厦门大学)，张煦尧 (中国科学院自动化研究所)，王立元 (清华大学)，杨若峰 (上海交通大学)，候臣平 (国防科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江穆厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 18：自动驾驶</div>
                <div class="parallel-meta">组织者：赵恒爽（香港大学），马超（上海交通大学），王兴刚（华中科技大学）</div>
                <div class="parallel-meta">讲者：张力 (复旦大学)，秦通 (上海交通大学)，苏鹏 (华为)，蒋理 (香港中文大学(深圳))，金鑫 (宁波东方理工大学)，梁定康 (华中科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江耀厅</div>
              </div>
              <div class="parallel-item">
                <div class="parallel-name">Workshop 19：三维视觉与空间智能</div>
                <div class="parallel-meta">组织者：郭裕兰（中山大学）、崔兆鹏（浙江大学）、王龙光（中山大学）</div>
                <div class="parallel-meta">讲者：周晓巍 (浙江大学)，雷印杰 (四川大学)，杨欣 (华中科技大学)，王冰 (香港理工大学)，董震 (武汉大学)，徐旦 (香港科技大学)</div>
                <div class="parallel-meta" style="font-weight: bolder;color: blueviolet;">地点：3F江海厅</div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Program"
}
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/sub_banner/02.jpg");
  }
  .footer{
    bottom: 0;
  }
  .font-bolder{
    font-weight: bolder;
  }
  .item-content-title{
    font-weight: bolder;
    font-size: 18px;
    margin-bottom: 8px;
    margin-top: 24px;
    color: #0053a1;
  }
  .item-content-info{
    text-align: left;
    margin-bottom: 16px;
  }
  .text-black-border{
    font-weight: bold;
  }
  .schedule-note{
    font-size: 14px;
    color: #606266;
    margin-top: 8px;
  }
  .parallel-hint{
    text-align: left;
    margin: 12px 0 8px;
    font-size: 15px;
  }
  .parallel-hint-highlight{
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-left: 4px solid #d39e00;
    border-radius: 6px;
    padding: 10px 12px;
  }
  .parallel-list{
    text-align: left;
    margin-bottom: 8px;
  }
  .parallel-item{
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 10px 12px;
    margin-bottom: 10px;
    background: #fafafa;
  }
  .parallel-name{
    font-weight: bold;
    color: #409EFF;
    margin-bottom: 6px;
  }
  .parallel-meta{
    font-size: 14px;
    line-height: 1.6;
    color: #303133;
  }
  .doc-download{
    margin-top: 24px;
    text-align: left;
    font-size: 14px;
  }
  .doc-download a{
    color: #409EFF;
  }
  .time-td{
    width: 100px;
    min-width: 100px;
    max-width: 110px;
    vertical-align: top;
  }
  .didian-td{
    width: 90px;
    min-width: 80px;
    vertical-align: top;
    text-align: center;
  }
  .program-table{
    width: 100%;
    margin: 4px 0 16px;
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
  }
  .program-table td,.program-table th{
    border-right: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  .program-table th{
    height: 40px;
    background: #f5f7fa;
  }
  .program-table td{
    padding: 8px 6px;
    font-size: 14px;
    vertical-align: top;
  }
  .font-weight{
    font-weight: bold;
  }
  .td-title{
    padding: 2px 0;
    color: #409EFF;
    font-weight: bold;
  }
  .td-content{
    text-align: left;
    line-height: 1.55;
  }
  .text-indent-two{
    text-indent: 2em;
  }
  .main-container{
    margin: 50px auto;
    width: 90%;
    max-width: 960px;
  }
  @media screen and (max-width: 600px){
    .main-container{
      width: 94%;
    }
    .time-td{
      max-width: 88px;
      font-size: 12px;
    }
    .program-table td{
      font-size: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Program.vue